module.exports = __webpack_public_path__ + "img/S_RECHERCHE.df1e87e2.svg";